import { render, staticRenderFns } from "./TransferProducts.vue?vue&type=template&id=d230e938&scoped=true&"
import script from "./TransferProducts.vue?vue&type=script&lang=js&"
export * from "./TransferProducts.vue?vue&type=script&lang=js&"
import style0 from "./TransferProducts.vue?vue&type=style&index=0&id=d230e938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d230e938",
  null
  
)

export default component.exports